/* eslint-disable @typescript-eslint/dot-notation */
import {AfterViewInit, Component, inject, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {ModalComponent} from 'app/core/modal.component';
import {Form} from 'app/entities/form/form.entity';
import {ApiResponse} from 'app/entities/apiResponse.entity';
import {AppService} from 'app/services/app.service';
import {FormElementComponent} from 'app/components/form/formConstructor/form/item';
import {Blocks} from 'app/entities/blockElements/block.entity';
import {plainToInstance} from 'class-transformer';


@Component({
  selector: 'app-form-modal',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class FormModalComponent extends ModalComponent implements OnInit, AfterViewInit {

  @ViewChild('formElement') formElement: FormElementComponent;

  appService = inject(AppService);

  getFormSettings: (callback: (response: ApiResponse) => void) => void;
  saveForm: (id: number, values: any, callback: (response: ApiResponse) => void) => void;
  updateForm: (id: number, values: any, callback: (response: ApiResponse) => void) => void;

  formId: number = null;  // non exist form
  formFieldId: number = null; // exist form
  values: any = null;

  title: string;
  showModalTitle = false;
  subTitle: string = null;

  // loading = true;
  loadingFinished = false;

  loadingRequest = false;
  // acceptButtonTexts нужен для замены текста в acceptButton зависящем от статуса загрузки
  acceptButtonTexts = ['Сохранить', 'Сохраняем', 'Сохранено!'];
  loadingRequestWaiting = false;
  loadingRequestText = 'Сохранить';
  loadingRequestTextTimer = null;

  header: Blocks[] = [];
  form: Form;

  constructor(
    modalController: ModalController
  ) {
    super(modalController);
  }

  // @todo move to setters
  ngOnInit() {
    this.loadingFinished = false;
    this.loadingRequestText = this.acceptButtonTexts[0];
    if (this.getFormSettings) {

      this.getFormSettings((response) => {

        if (response.status) {
          this.header = response.result.header;

          const form = response.result.form;
          if (this.isFormExist()) {
            form.fieldId = this.getFormId();
          } else {
            form.id = this.getFormId();
          }

          if (this.values) {
            form.values = this.values;
          }

          this.form = plainToInstance(Form, form);

          this.formElement.build(this.form.fields, this.form.values);
        } else {

          if (response.message) {
            this.appService.showToast(response.message, 'danger');
          }

          this.closeModal();
        }
        this.formLoaded();
      });
    }
  }

  ngAfterViewInit(): void {

  }

  formSubmit(result) {
    this.closeModal(result);
  }

  formLoaded() {
    this.loadingFinished = true;
  }

  getFormId() {
    return this.isFormExist() ? this.formFieldId : this.formId;
  }

  isFormExist() {
    return typeof this.formFieldId !== 'undefined' && !!this.formFieldId;
  }

  cancel() {
    if (!this.loadingRequestWaiting) {
      this.formSubmit(null);
    }
  }

  submitAndClose() {
    if (this.formElement.validate()) {
      this.saveAndClose();
    }
  }

  async saveAndClose() {
    if (!this.loadingRequestWaiting) {
      this.startRequestLoading();

      await this.formElement.beforeSubmit();

      console.log(this.formElement.value());

      if (this.form.isExist()) {
        this.updateForm(this.form.getId(), this.formElement.value(), (response: ApiResponse) => {
          this.handleResponse(response);
        });
      } else {
        this.saveForm(this.form.getId(), this.formElement.value(), (response: ApiResponse) => {
          this.handleResponse(response);
        });
      }
    }
  }

  handleResponse(response: ApiResponse) {

    if (response.status) {

    } else {
      if (response.message) {
        this.appService.showToast(response.message, 'danger');
      }
    }

    this.stopRequestLoading(response.status, () => {
      if (response.status) {
        this.formSubmit(response.result);
      }
    });
  }

  // @todo вынести в компоненту
  startRequestLoading() {
    this.loadingRequest = true;
    this.loadingRequestWaiting = true;

    this.loadingRequestText = this.acceptButtonTexts[1];
  }

  stopRequestLoading(status: boolean, callback: () => void) {
    this.loadingRequest = false;

    this.loadingRequestText = status ? this.acceptButtonTexts[2] : 'Ошибка!';

    if (this.loadingRequestTextTimer) {
      clearTimeout(this.loadingRequestTextTimer);
    }

    this.loadingRequestTextTimer = setTimeout(() => {
      this.loadingRequestWaiting = false;
      this.loadingRequestText = this.acceptButtonTexts[0];

      callback();
    }, status ? 1000 : 3000);
  }
}
